module.exports = __webpack_public_path__ + "static/media/27.74eb0429.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/27.jpg
// module id = 588
// module chunks = 0